import {
  Directive,
  EmbeddedViewRef,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';

@Directive({
  selector: '[cerViewRecreateCount]'
})
export class CerViewRecreateDirective implements OnChanges {
  
  @Input('CerViewRecreateCount') count: any;

  viewRef: EmbeddedViewRef<any>;

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['count']) {
      if (this.viewRef) {
        this.viewRef.destroy();
        this.viewRef = null;
      }
      this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
